import {useEffect, useState} from 'react'
import {Link as RouterLink} from 'react-router-dom'

import Button from '@mui/material/Button'
import RecoveryIcon from '@mui/icons-material/GroupsOutlined'
import Stack from '@mui/material/Stack'
import WarningIcon from '@mui/icons-material/GppMaybe'

import Greetings from './Greetings'
import InfoTile from '../shared/InfoTile'
import Loader from '../shared/Loader'

import {connect} from '../../state/hooks/tools'
import {filterRecordsByAttribute, findRecordByAttribute} from '../../lib/data'
import {isEmpty} from '../../lib/tools'
import {isRecoveryOpen, recoveryNotice} from '../../lib/recovery'
import {readEndpoint} from '../../lib/asyncMethods'
import {RECOVERY_INVITES, RECOVERY_REQUEST} from '../../state/actionTypes'

import './dashboard.scss'

const DashboardController = props => {
  // Nothing is shown until the answer is known: a user who already has contacts should never be
  // told to go and add some, however briefly.
  const [recoveryLoaded, setRecoveryLoaded] = useState(false)
  const recovering = isRecoveryOpen(props.recovery)

  useEffect(() => {
    Promise.all([
      props.fetchRecoveryInvites('recovery-invites'),
      props.fetchRecovery('recovery-requests')
    ]).finally(() => setRecoveryLoaded(true))
  }, [])

  return (
    <Loader loading={isEmpty(props.currentUser)}>
      <Stack component='div' className='dashboard'>
        {!isEmpty(props.currentUser) && <Greetings currentUser={props.currentUser} email={props.email} />}
        {
          recoveryLoaded && (
            // an account waiting on its contacts has nothing to gain from being told to set recovery
            // up, so the two prompts never appear together
            recovering ? (
              <InfoTile
                className='recovery-prompt'
                icon={WarningIcon}
                label='Finish recovering your account'
                details={[recoveryNotice(props.recovery)]}>
                <Button className='action' component={RouterLink} to='/dashboard/recovery' size='small'>
                  Continue
                </Button>
              </InfoTile>
            ) : isEmpty(props.recoveryInvites) && (
              <InfoTile
                className='recovery-prompt'
                icon={RecoveryIcon}
                label='Set up account recovery'
                details={['If you forget your password, recovery contacts are the only way back into your account']}>
                <Button className='action' component={RouterLink} to='/dashboard/recovery' size='small'>
                  Choose your contacts
                </Button>
              </InfoTile>
            )
          )
        }
      </Stack>
    </Loader>
  )
}

const mapStateToProps = state => {
  const {currentUser = {}} = state.users
  const {emails} = state.emails
  const data = filterRecordsByAttribute({records: emails, attribute: 'userId', id: currentUser.id})
  const primaryEmail = findRecordByAttribute({records: data, attribute: 'category', id: 'primary'})

  return {
    ...state.users,
    emails: data,
    email: primaryEmail,
    recoveryInvites: state.recovery.recoveryInvites || [],
    recovery: (state.recoveryRequest.recoveryRequest || [])[0] || {}
  }
}

const actionCreators = ({recovery, recoveryRequest}) => ({
  fetchRecoveryInvites: readEndpoint(recovery, RECOVERY_INVITES),
  fetchRecovery: readEndpoint(recoveryRequest, RECOVERY_REQUEST)
})

export default connect(mapStateToProps, actionCreators)(DashboardController)
